import { isDate } from "../typeMatchers";

const OBJECT_TYPES = ["object", "function"];

/**
 * Checks this object is an assignable object
 */
export const assignable = (target: Record<string | symbol, any>): boolean =>
	OBJECT_TYPES.includes(typeof target) && target !== null && !isDate(target);
